<template>
  <div class="addresses">
    <SfTabs key="edit-address" :open-tab="1" class="tab-orphan">
      <SfTab :title="$t('My Addresses')">
        <p>
          {{ $t(`Manage all the shipping addresses you want (work place, home address
          ...) This way you won't have to enter the shipping address manually
          with each order.`) }}
        </p>
          <transition-group
          tag="div"
          name="fade"
          v-if="customer.Addresses && customer.Addresses.length && !isAddAddress"
          class="fz-address-view"
        >
        <div v-for="(userAddress) in customer.Addresses" :key="userAddress.Id">
          <AddressItem
            :address="userAddress"
            @changeAddress="onChangeAddress"
            @removeAddress="onRemoveAddress"
          />
        </div>
        </transition-group>

        <SfButton
          class="action-button"
          @click="addNewAddress"
          v-if="!isAddAddress"
        >
          {{ $t('Add new address') }}
        </SfButton>
        <div v-else>
          <SfDivider />
          <br />
          <EditAddress
            :key="address ? address.Id : new Date().toString()"
            :address="address"
            @cancelAddress="isAddAddress = !isAddAddress"
            @submitAddress="onSubmitAddress"
          />
          <br >
        </div>
      </SfTab>
    </SfTabs>
  </div>
</template>
<script>
import {
  SfTabs,
  SfButton,
  SfDivider,
} from '@storefront-ui/vue';
import AddressItem from './addresses/AddressItem.vue';
import EditAddress from './addresses/EditAddress.vue';
import user from '../../mixins/user';

export default {
  name: 'Addresses',
  mixins: [user],
  components: {
    SfTabs,
    SfButton,
    AddressItem,
    EditAddress,
    SfDivider,
  },
  data() {
    return {
      isAddAddress: false,
      address: undefined,
    };
  },
  methods: {
    addNewAddress() {
      this.address = undefined;
      this.isAddAddress = true;
    },
    onSubmitAddress(address) {
      const newAddress = {
        ...address,
        mainEmail: this.customer.Email,
      };

      if (address.Id) {
        this.updateAddress(newAddress);
      } else {
        this.addAddress(newAddress);
      }
      this.isAddAddress = false;
      this.address = undefined;
    },
    onChangeAddress(addressId) {
      this.isAddAddress = true;
      this.address = { ...this.customer.Addresses.find((item) => item.Id === addressId) };
    },
    onRemoveAddress(addressId) {
      this.deleteAddress({
        addressId,
        Email: this.customer.Email,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/_helpers";
@import "src/scss/_breakpoint.scss";
.tab-orphan {
  @include flexbox-mobile {
    --tabs-content-border-width: 0;
    --tabs-title-display: none;
    --tabs-content-padding: 0;
  }
}

.sf-button.action-button {
  @include flexbox-mobile {
    --button-width: 100%;
  }
}

p {
  margin-bottom: var(--spacer-sm);
}

.users hr {
  margin: var(--spacer-sm) auto;
  opacity: .2;
  width: 50%;
}

.fz-address-view {
  div {
    margin-bottom: var(--spacer-sm);
    padding: var(--spacer-xs);
  }

  div:nth-child(even) {
    background: lighten(gray, 40%);
  }
}
</style>
